import { EnterpriseListResponse, EnterpriseResponse } from "@/types/enterpriseTypes";
import { Client } from "./client";
import { EnterpriseParams } from "@/backend/access/enterprise/types";

export class EnterpriseController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  readAll(): Promise<EnterpriseListResponse> {
    return this.client.read('/api/enterprises');
  }

  read(id: string): Promise<EnterpriseResponse> {
    return this.client.read(`/api/enterprises/${id}`);
  }

  update(enterprise: EnterpriseParams): Promise<EnterpriseResponse> {
    return this.client.update('/api/enterprises', enterprise);
  }

  readByUserPropelOrgIdOrCreate(): Promise<EnterpriseResponse> {
    return this.client.read('/api/enterprises/propelOrgId');
  }
}

